import "../../../style/auth.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Loader from "../../../components/Loader";
import Modalcondition from "../components/modaltermecondition";
import { useSignupState } from "../../../hooks/auth/signup/index";
import { SignupForm } from "../../../components";

const Signup = () => {
  const signupState = useSignupState();

  if (signupState.isRegisterLoading || signupState.isSocialLoading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }

  const Selectezi = "Selectezi";
  return (
    <>
      <Modalcondition handleClose={signupState.handleClose} show={signupState.show} />
      <Container fluid>
        <Row className="sponsersettingrelative">
          <Col lg="2" md="2" sm="12" className="p-lg-5">
            <div>
              <h4 className="font-weight-bold selectezilogo">{Selectezi.toUpperCase()}</h4>
            </div>
          </Col>
          <Col lg="6" md="7" sm="12" className="mx-auto mt-4">
            <div className="center-data">
              <div className="Signup">
                <h3 className="mb-2 font-bold mt-lg-4">Sign Up</h3>
                <p className="login_font">
                  Sign up to create your profile to establish your business Shop
                  to join the business network where you can engage your
                  business with thousands of new clients along your area.
                </p>
              </div>
              <SignupForm {...signupState} />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Signup;
